import React, { FC, ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const ReCaptchaProvider: FC<ReactNode> = ({ children }) => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_CAPTCHA_KEY || ''}>
    {children}
  </GoogleReCaptchaProvider>
);
